import { connect } from 'react-redux';

import {
  setHasCookieConsent,
  setRejectAllCookies,
  setHasSavedCookieSettings,
} from 'app/marketplace/cookieDashboard/actions';
import { CookieBanner } from 'app/shared/components/CookieBanner/CookieBanner';

function mapStateToProps(state, props) {
  const { cookieDashboard } = state;
  const { location } = props;

  const isTheDashboardPage = location?.pathname?.includes('cookie-richtlinie');
  const isThePrivacyPage = location?.pathname?.includes('privacy');
  const shouldNotRender = isThePrivacyPage || isTheDashboardPage;

  return {
    shouldNotRender,
    hasSavedCookieSettings: cookieDashboard.hasSavedCookieSettings,
  };
}

export const ConnectedCookieBanner = connect(mapStateToProps, {
  setHasCookieConsent,
  setRejectAllCookies,
  setHasSavedCookieSettings,
})(CookieBanner);
